export const CREATE_CREATOR_CONTRACT_MUTATION = `
    mutation CreateContract(
        $project_id: Int!, 
        $project_creator_id: Int!, 
        $status_id: Int!, 
        $contact_value: Float!, 
        $kill_fee: Float!, 
        $content_ownership_id: Int!, 
        $content_rights: Int!, 
        $content_rights_expiration_date: String!,
        $ecom_asset_ownership: Int!,
        $indeminity: Boolean!,
        $whitelisting: Boolean!,
        $whitelisting_expiration: String!,
        $term_date: String!,
        $notes: String!
        $contract_upload: String! 
    ) {
        createContract(
            project_id: $project_id, 
            project_creator_id: $project_creator_id, 
            status_id: $status_id, 
            contact_value: $contact_value, 
            kill_fee: $kill_fee, 
            content_ownership_id: $content_ownership_id, 
            content_rights: $content_rights, 
            content_rights_expiration_date : $content_rights_expiration_date
            ecom_asset_ownership: $ecom_asset_ownership,
            indeminity: $indeminity,
            whitelisting: $whitelisting,
            whitelisting_expiration: $whitelisting_expiration,
            term_date: $term_date,
            notes: $notes,
            contract_upload: $contract_upload
        ) {
            id
            status
            contract_value
            kill_fee
            content_ownership
            content_rights
            content_rights_expiration_date
            ecom_asset_ownership
            indeminity
            whitelisting
            whitelisting_expiration
            term_date
            notes
    }
`;

export const UPDATE_CREATOR_CONTRACT_MUTATION = `
    mutation UpdateContract(
        $project_id: Int!, 
        $project_creator_id: Int!, 
        $status: ProjectContractStatusEnum, 
        $contract_value: Float, 
        $kill_fee: Float, 
        $content_ownership: ProjectContractContentOwnershipEnum, 
        $content_rights: ProjectContractContentRightsEnum, 
        $content_rights_expiration_date: String,
        $ecom_asset_ownership: ProjectContractEcomAssetOwnershipEnum,
        $ecom_asset_expiration_date: String,
        $indeminity: Boolean,
        $whitelisting: Boolean,
        $whitelisting_expiration: String,
        $term_date: String,
        $notes: String
        $contract_upload: String 
    ) {
        updateContract(
            project_id: $project_id, 
            project_creator_id: $project_creator_id, 
            status: $status, 
            contract_value: $contract_value, 
            kill_fee: $kill_fee, 
            content_ownership: $content_ownership, 
            content_rights: $content_rights, 
            content_rights_expiration_date: $content_rights_expiration_date,
            ecom_asset_ownership: $ecom_asset_ownership,
            ecom_asset_expiration_date: $ecom_asset_expiration_date,
            indeminity: $indeminity,
            whitelisting: $whitelisting,
            whitelisting_expiration: $whitelisting_expiration,
            term_date: $term_date,
            notes: $notes,
            contract_upload: $contract_upload
        ) {
            id
            status
            contract_value
            kill_fee
            content_ownership_id
            content_rights
            content_rights_expiration_date
            ecom_asset_ownership
            ecom_asset_expiration_date
            indeminity
            whitelisting
            whitelisting_expiration
            term_date
            notes
            uploads {
                id
                filename
                thumbnail
                tag
                type
            }
        }    
    }
`;

export const DELETE_CREATOR_CONTRACT_MUTATION = `
    mutation DeleteContract($project_id: Int!, $project_creator_id: Int!) {
        deleteContract(project_id: $project_id, project_creator_id: $project_creator_id) {
            id
            status
            contract_value
            kill_fee
            content_ownership
            content_rights
            content_rights_expiration_date
            ecom_asset_ownership
            indeminity
            whitelisting
            whitelisting_expiration
            term_date
            notes
        }
    }

`;

export const DOWNLOAD_CREATOR_CONTRACT_MUTATION = `
    mutation DownloadContract($project_id: Int!, $project_creator_id: Int!) {
        downloadContract(project_id: $project_id, project_creator_id: $project_creator_id)
    }
`;

export const SUBMIT_CREATOR_CREATIVE_BRIEF_MUTATION = `
    mutation SubmitCreativeBrief($project_id: Int!, $project_creator_id: Int!, $content: String!) {
        submitCreativeBrief(project_id: $project_id, project_creator_id: $project_creator_id, content: $content) {
            id
            content {
                id
                content
            }
            all_revisions {
                id
                content
            }
        }
    }
`;
